export default [
	{
		id: 1,
		type: "text",
		title: "Persönliche Angaben",
		items: [
			{
				id: 1,
				type: "small",
				text: "Semester",
			},
			{
				id: 2,
				type: "medium",
				text: "Studiengang",
			},
		],
	},
	{
		id: 2,
		type: "matwis-p",
		title: "Wie bewerten Sie diese Veranstaltung (in Schulnoten)?",
		rowTitle: "Praktikumsversuch",
		items: [
			{
				id: 3,
				text: "Rheologie von Fluiden (Falk, BetreuerIn: Christian Oswald, Doris Ranker)",
			},
			{
				id: 4,
				text: "Gleichstrom, Ohm, Kirchhoff (Motz, BetreuerIn: Florentin Gaub)",
			},
			{
				id: 5,
				text: "Dichte, Volumen, Poren (Falk, BetreuerIn: Christian Oswald, Doris Ranker)",
			},
			{
				id: 6,
				text: "Mechanische Schwingungen (Herrmann, BetreuerIn: Hendrik Jost)",
			},
			{
				id: 7,
				text: "Statik / Mechanik (Diebels, BetreuerIn: Robin Reinardt, Alexander Bäumchen)",
			},
			{
				id: 8,
				text: "Hookesches Gesetz (Diebels, BetreuerIn: Robin Reinardt, Alexander Bäumchen)",
			},
			{
				id: 9,
				text: "Reibung und schiefe Ebene (Diebels, BetreuerIn: Robin Reinardt, Alexander Bäumchen)",
			},
			{
				id: 10,
				text: "Löten elektronischer Schaltungen (Fachrichtung, BetreuerIn: Jürgen Klesen)",
			},
			{
				id: 11,
				text: "Spaß mit Polymeren Teil 1: Herstellung eines Nylonfades und eines PU-Schaums (Lienkamp, BetreuerIn: Sophie Schneider, Lea Sollka)",
			},
			{
				id: 12,
				text: "Spaß mit Polymeren Teil 2: Herstellung eines Nylonfades und eines PU-Schaums (Lienkamp, BetreuerIn: Sophie Schneider, Lea Sollka)",
			},
		],
	},
	{
		id: 3,
		type: "text",
		items: [
			{
				id: 13,
				text: 'Gerne können Sie auch Lob und Kritik angeben. Insbesondere falls Sie "Sehr gut" oder "Mangelhaft" angekreuzt haben, würde uns der Grund interessieren:',
			},
		],
	},
];
